module.exports = __webpack_public_path__ + "../resources/images/bold-3d0c5eac4ea3d22c35b4019e4d3cfaac.svg";